import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import { MODALS } from '../../constants';
import FullScreenLoader from '../FullScreenLoader';

import './styles.css';

const ShareModalLoadable = loadable(() => import('./ShareModalLoadable'), {
  fallback: <FullScreenLoader />,
});

const ShareModal = props => {
  const modalName = MODALS.SHARE;

  return (
    <Modal name={modalName} {...props}>
      <ShareModalLoadable />
    </Modal>
  );
};

ShareModal.propTypes = {
  children: PropTypes.node,
};

ShareModal.defaultProps = {
  children: undefined,
};

export default ShareModal;
